import React from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
// eslint-disable-next-line
import '@splidejs/react-splide/css';

import {
  WelcomeGameCtaButton,
  WelcomeGameHtmlZone,
  WelcomeGameDisplaySection,
  WelcomeGameImgSection,
  WelcomeGameTxt,
  WelcomeGameThumbnail,
  LeftSliderArrow,
  RightSliderArrow,
} from './WelcomeGameScreen.style';
import { MultiGameScreenConfiguration, SingleGameScreenConfiguration } from '../../common-types/ScreensConfigurations.type';
import { Background } from '../common-components/Background';
import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { ReactComponent as SliderArrowSVG } from '../images/slider-arrow.svg';

interface Props {
  config: MultiGameScreenConfiguration | SingleGameScreenConfiguration;
  ctaOnClick?: React.MouseEventHandler<HTMLDivElement>;
  addEditableBlock?: (block: BlockInfoType) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  thumbnailUrls: { campId: string, url: string }[];
  welcomeGameScreenType: 'singleGame' | 'multiGame';
}

export const WelcomeGameScreen: React.FunctionComponent<Props> = ({
  addEditableBlock,
  config,
  ctaOnClick,
  isEdition,
  onBlockEdit,
  thumbnailUrls,
  welcomeGameScreenType,
} : Props) => {
  return (
    <Background
      displayName="Background"
      sizeInfo={{ height: 1200, width: 1200 }}
      addEditableBlock={addEditableBlock}
      dataTemplateConfig={`screens.${welcomeGameScreenType}.background`}
      backgroundImage={config.background.imageUrl}
      backgroundColor={config.background.color}
      isEdition={isEdition}
      onClick={onBlockEdit}
    >
      <WelcomeGameHtmlZone
        displayName="HTML Zone"
        addEditableBlock={addEditableBlock}
        html={config.mainTextBox.html}
        dataTemplateConfig={`screens.${welcomeGameScreenType}.mainTextBox`}
        isEdition={isEdition}
        onClick={onBlockEdit}
      />
      <WelcomeGameCtaButton
        displayName="CTA"
        addEditableBlock={addEditableBlock}
        backgroundColor={config.ctaButton.background.color}
        innerHTML={config.ctaButton.html}
        onClick={
          onBlockEdit === undefined
            ? ctaOnClick
            : onBlockEdit
        }
        dataTemplateConfig={`screens.${welcomeGameScreenType}.ctaButton`}
        isEdition={isEdition}
      />
      <WelcomeGameDisplaySection>
        <WelcomeGameTxt
          displayName="HTML Zone"
          addEditableBlock={addEditableBlock}
          html={config.thumbnailTextBox.html}
          dataTemplateConfig={`screens.${welcomeGameScreenType}.thumbnailTextBox`}
          isEdition={isEdition}
          onClick={onBlockEdit}
        />
        <WelcomeGameImgSection>
          <Splide
            hasTrack={false}
            options={{
              type: 'slide',
              pagination: false,
              gap: '4vw',
              perPage: 3,
              perMove: 1,
            }}
          >
            <SplideTrack>
              {
                thumbnailUrls.map((thumbnail) => <SplideSlide key={thumbnail.campId}>
                  <WelcomeGameThumbnail src={thumbnail.url} alt="thumbnail" />
                </SplideSlide>)
              }
            </SplideTrack>
            <div className="splide__arrows">
              <LeftSliderArrow className="splide__arrow splide__arrow--prev"><SliderArrowSVG /></LeftSliderArrow>
              <RightSliderArrow className="splide__arrow splide__arrow--next"><SliderArrowSVG /></RightSliderArrow>
            </div>
          </Splide>
        </WelcomeGameImgSection>
      </WelcomeGameDisplaySection>
    </Background>
  );
};
